import { Col, Row } from "antd";
import moment from "moment/moment";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { BsTelephoneFill } from "react-icons/bs";
import { FaPause } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";

import { CallRejectionIcon, HoldIcon, MicIcon } from "../assets/Icons";
import dialxyApi from "../store/endpoints";
import {
  setIsDiscardButtonDisabled,
  setOngoingCallTime,
} from "../store/features/dialer/callStatusSlice";
import {
  setCallInfoData,
  setHangupCallStatus,
  setHoldUnholdCallStatus,
  setMuteUnmuteCallStatus,
} from "../store/features/dialer/deviceSlice";
import { type RootState } from "../store/store";
import { CALL_STATE } from "../utils/constants";
import { truncate } from "../utils/string";
import Avatar from "../components/Avatar";
import { customPhoneNumberFormatter } from "../utils/number";
import { setMakeCallData } from "../store/features/dialer/activeCollapseSlice";

const CallDialed = () => {
  const { t } = useTranslation();

  const { ongoingCallTime } = useSelector(
    (state: RootState) => state.callStatus
  );

  const numRef = useRef<HTMLInputElement | null>(null);
  const dispatch = useDispatch();

  const {
    callState,
    isIncoming,
    isOnCall,
    acceptIncomingCallStatus,
    holdUnholdCallStatus,
    muteUnmuteCallStatus,
  } = useSelector(
    (state: {
      device: {
        activeCallData: { from: string };
        callState: any;
        isIncoming: boolean;
        isOnCall: boolean;
        acceptIncomingCallStatus: any;
        holdUnholdCallStatus: boolean;
        muteUnmuteCallStatus?: boolean;
      };
    }) => state?.device
  );

  const { makeCallData } = useSelector(
    (state: {
      activeCollapse: {
        makeCallData: {
          name: string;
          my_phone_number: string;
          dialingcode: string;
          number: string;
        };
      };
    }) => state.activeCollapse
  );
  const { isDiscardButtonDisabled } = useSelector(
    (state: {
      callStatus: {
        isDiscardButtonDisabled: boolean;
      };
    }) => state?.callStatus
  );
  const handleMuteUnmute = () => {
    if (muteUnmuteCallStatus) {
      dispatch(setMuteUnmuteCallStatus(false));
    } else {
      dispatch(setMuteUnmuteCallStatus(true));
    }
  };

  const handleHoldUnhold = () => {
    if (holdUnholdCallStatus) {
      dispatch(setHoldUnholdCallStatus(false));
    } else {
      dispatch(setHoldUnholdCallStatus(true));
    }
  };

  useEffect(() => {
    setTimeout(() => {
      !isIncoming && dispatch(setIsDiscardButtonDisabled(false));
    }, 3000);
  }, []);

  // CONNECTING STATE
  const isConnecting =
    callState === CALL_STATE.DESTROY ||
    callState === CALL_STATE.NEW ||
    callState === CALL_STATE.REQUESTING;
  // ISRINGING
  const isRinging = callState === CALL_STATE.TRYING;
  //   ISANSWERING;
  const isAnswering = callState === CALL_STATE.ANSWERING;

  // CALL ON PROGRESS
  const hasTimeStarted =
    callState === CALL_STATE.ACTIVE ||
    callState === CALL_STATE.CONNECTING ||
    callState === CALL_STATE.ACCEPTED ||
    callState === CALL_STATE.HELD;
  const showButtons = !isIncoming || acceptIncomingCallStatus;

  const displayName = () => {
    if (makeCallData?.name && !makeCallData?.name.startsWith("+")) {
      return makeCallData?.name;
    }
    return "Unkown number";
  };
  return (
    <div className={` wrapper`}>
      <div className="flex header">
        <div className="flex">
          <div className="avatar">
            <Avatar size="small" className="font-normal" name={displayName()} />
          </div>
          <div className="w-full flex">
            <div className="overflow-hidden whitespace-nowrap">
              {makeCallData && (
                <div
                  ref={numRef}
                  className={`user-detail`}
                  title={displayName()}
                >
                  {truncate(displayName(), 20)}
                  <p className="text-[#666666] mb-0 text-xs font-medium">
                    {`${
                      customPhoneNumberFormatter(
                        makeCallData?.dialingcode! + makeCallData?.number
                      )
                        ? customPhoneNumberFormatter(
                            makeCallData?.dialingcode! + makeCallData?.number
                          )
                        : makeCallData?.number
                    }`}
                  </p>
                </div>
              )}
            </div>
          </div>
          {/* Outgoing call number */}
        </div>
        <div className="text-xs text-66">
          {isConnecting && "Connecting..."}
          {isRinging && "Ringing..."}
          {isAnswering && "Answering..."}
          {hasTimeStarted && (
            <div className="badge mx-auto flex w-fit items-center justify-center rounded-[100px] bg-[#E0E0E0] px-[7px] py-[4px] text-[12px] leading-[16px]">
              <span className="flex items-center justify-center">
                {holdUnholdCallStatus ? (
                  <FaPause size={12} className="mr-[4px] text-[#474747]" />
                ) : (
                  <BsTelephoneFill
                    size={12}
                    className="mr-[4px] text-[#474747]"
                  />
                )}
              </span>
              <span>
                {ongoingCallTime >= 3600
                  ? moment.utc(ongoingCallTime * 1000).format("HH:mm:ss")
                  : moment.utc(ongoingCallTime * 1000).format("mm:ss")}
              </span>
              {holdUnholdCallStatus ? (
                <span className="ml-1">On Hold</span>
              ) : (
                <></>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="action_menu">
        <Row gutter={[20, 20]}>
          {showButtons && (
            <>
              <Col
                className={`text-center ${
                  isOnCall ? "opacity-100" : "opacity-60"
                } `}
              >
                <button
                  onClick={() => isOnCall && handleHoldUnhold()}
                  className={`inline-flex h-[48px] w-[48px] items-center justify-center rounded-[32px] ${
                    holdUnholdCallStatus
                      ? "bg-[#474747] text-white"
                      : "focus:[#E0E0E0] active:[#E0E0E0] bg-[#f5f5f5] hover:bg-[#F1F2F4]"
                  } `}
                  disabled={isOnCall ? false : true}
                >
                  <span className="">
                    <HoldIcon
                      color={`${holdUnholdCallStatus ? "#ffffff" : "#666666"}`}
                    />
                  </span>
                  {/* </span> */}
                </button>
              </Col>

              <Col className={`text-center ${isOnCall ? "" : "opacity-60"}`}>
                {/* Button to mute/unmute */}
                <button
                  onClick={() => isOnCall && handleMuteUnmute()}
                  className={`inline-flex h-[48px] w-[48px] items-center justify-center rounded-[32px] ${
                    muteUnmuteCallStatus
                      ? "bg-47 text-white"
                      : "focus:[#E0E0E0] active:[#E0E0E0] bg-[#f5f5f5] hover:bg-[#F1F2F4]"
                  } `}
                  disabled={isOnCall ? false : true}
                >
                  <span className="flex h-24">
                    <MicIcon
                      color={muteUnmuteCallStatus ? "#ffffff" : "#666666"}
                    />
                  </span>
                </button>
                {/* <span className="text-grey-700 mt-[8px] block text-[12px] font-medium leading-[16px] tracking-[.02em]">
                    {isMuted ? "Unmute" : "Mute"}
                  </span> */}
              </Col>
            </>
          )}
        </Row>
        {/* Call Rejecting Button */}
        <div className="flex flex-col items-center">
          <button
            onClick={(e) => {
              e.stopPropagation();
              dispatch(setCallInfoData(null));
              dispatch(setHangupCallStatus(true));
              dispatch(setMakeCallData(null));
              dispatch(setOngoingCallTime("reset"));
              dialxyApi.util.invalidateTags([{ type: "CallLog" }]);
              window.close();
            }}
            className={`mx-auto flex h-[48px] w-[48px] items-center justify-center rounded-full bg-error ${
              isDiscardButtonDisabled && !isIncoming
                ? "pointer-events-none bg-opacity-90"
                : ""
            }`}
            disabled={isDiscardButtonDisabled && !isIncoming}
          >
            <span className="h-24">
              <CallRejectionIcon />
            </span>
          </button>
          {isIncoming && !isOnCall ? (
            <span className="mt-1.5 text-xs font-medium text-[#1f1f1f]">
              {t("global_decline_text")}
            </span>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default CallDialed;
